/*
 * The membership sale, in one place.
 *
 * Two pages quote the introductory offer: the plans page and the homepage
 * portal. Both need the same three answers — what the discount is, what the
 * first year therefore costs, and what percentage that saves against paying
 * monthly — and if they work them out separately they will eventually
 * disagree, which is worse than either being wrong on its own.
 *
 * These are the formulas from assets/od-membership-plans.js, moved out
 * verbatim. That file has not been changed to call them yet: it is the live
 * pricing page and the swap deserves its own testing. Until then this is the
 * canonical copy, and anything new uses it.
 */
(function () {
  "use strict";

  var ENDPOINT = '/apps/library/active-sale';

  /*
   * Only the membership sale, never the storewide one. The storewide
   * percentage cannot reach a subscription, so quoting it would promise a
   * saving no charge could honour.
   */
  function percentageFrom(data) {
    var sale = data && data.membershipSale;
    var value = Number(sale && sale.percentage);

    return isFinite(value) && value > 0 && value < 100 ? value : 0;
  }

  /*
   * Resolves to 0 rather than rejecting. A page that cannot reach the endpoint
   * still has correct standing prices on it, so failing quietly undersells
   * where throwing would leave the prices half-written.
   */
  function fetchPercentage() {
    if (typeof window.fetch !== 'function') return Promise.resolve(0);

    return window
      .fetch(ENDPOINT, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(percentageFrom)
      .catch(function () { return 0; });
  }

  /** What the first year costs, in cents, at a given discount. */
  function introCents(annualCents, percentage) {
    var annual = Number(annualCents);
    var percent = Number(percentage);

    if (!isFinite(annual) || annual <= 0) return null;
    if (!isFinite(percent) || percent <= 0 || percent >= 100) return null;

    var first = Math.round((annual * (100 - percent)) / 100);

    /* A discount that saves nothing is not worth announcing. */
    return first < annual ? first : null;
  }

  /**
   * What a year costs against twelve months of the monthly price.
   *
   * The introductory discount only ever reaches the annual plans, so while a
   * sale is running this is far larger than the standing saving: 37% rather
   * than 17% at a quarter off. Both figures come off the card, so neither is
   * typed anywhere.
   */
  function yearlySavingPercent(annualCents, monthlyYearCents, percentage) {
    var annual = Number(annualCents);
    var monthlyYear = Number(monthlyYearCents);

    if (!isFinite(annual) || !isFinite(monthlyYear) || monthlyYear <= 0) return null;

    var payable = introCents(annual, percentage);
    if (payable === null) payable = annual;

    var percent = Math.round(((monthlyYear - payable) / monthlyYear) * 100);

    return percent > 0 ? percent : null;
  }

  window.ODMembershipSale = {
    fetchPercentage: fetchPercentage,
    percentageFrom: percentageFrom,
    introCents: introCents,
    yearlySavingPercent: yearlySavingPercent
  };
})();
